import React, { useState, useEffect } from "react";

function CopyLinkButton(props) {
    const [copied, setCopied] = useState(false);

    function copyToClipboard() {
        const el = document.createElement("textarea");
        el.value = props.link;
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);

        setCopied(true);
    }

    useEffect(() => {
        let timer;
        if (copied) {
            timer = setTimeout(() => {
                setCopied(false);
            }, 3000);
        }
        return () => {
            clearTimeout(timer);
        };
    }, [copied]);

    const copiedStyle = {
        color: "green",
        transition: "opacity 0.5s ease-in-out",
        opacity: copied ? 1 : 0,
        marginLeft: "50px",
    };

    return (
        <a
            style={{
                textDecoration: "none",
                color: "black",
                fontSize: "20px",
                fontWeight: "400",
                marginLeft: "100px",
            }}
            href={props.link}
            onClick={(e) => {
                e.preventDefault();
                copyToClipboard();
            }}
        >
            Скопировать ссылку на тариф в шопе
            <span style={copiedStyle}>{copied ? " Скопировано" : ""}</span>
        </a>
    );
}

export default CopyLinkButton;
